import React from "react"
import classnames from "classnames"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

export default function TestimonialsCarousel({
  className,
  slides,
  setSlides,
  children,
}) {
  var settings = {
    adaptiveHeight: true,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  return (
    <div className={classnames("carousel-wrapper big-quotes ", className)}>
      <div className="container narrow">
        <h2 className="carousel-title">Testimonials</h2>
        <div className="carousel">
          <Slider {...settings}>{children}</Slider>
        </div>
      </div>
    </div>
  )
}
